import { initGlobalState, MicroAppStateActions } from 'qiankun';

type TAuthExcludedItems = {
  resourceID: string;
  resourceName: string;
  contracts: {
    policyID: string;
    contractID: string;
  }[];
}[];

interface GlobalState {
  // 授权处理器弹窗显示
  authProcessorShow: boolean;
  // 授权方 id
  licensorId: string;
  itemId: string;
  authExcludedItems: TAuthExcludedItems;
  licensorResourceVersion: string;
  licenseeVersion: string;
}

const defaultGlobalState: GlobalState = {
  authProcessorShow: false,
  licensorId: '',
  itemId: '',
  authExcludedItems: [],
  licensorResourceVersion: '',
  licenseeVersion: '',
};

class MicroAppStateActionsMgr {
  public static get actions(): MicroAppStateActions {
    return this.inst._actions;
  }

  public static get state(): GlobalState {
    return this.inst._state;
  }

  public static setState(state: Partial<GlobalState>) {
    this.actions.setGlobalState(state);
  }

  private static _inst: MicroAppStateActionsMgr;
  private static get inst(): MicroAppStateActionsMgr {
    if (this._inst == null) {
      this._inst = new MicroAppStateActionsMgr();
    }
    return this._inst;
  }

  private _actions: MicroAppStateActions;

  private _state: GlobalState = defaultGlobalState;

  private constructor() {
    this._actions = initGlobalState(defaultGlobalState);
    this._actions.onGlobalStateChange((state: any, prev: any) => {
      this._state = { ...this._state, ...state };
    });
  }
}

export default MicroAppStateActionsMgr;
